module.exports = __webpack_public_path__ + "static/img/ESGS2021E.dd08757.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ESGS2021E.png
// module id = ndLY
// module chunks = 1